<template>
  <div class="pitches-wrapper">
    <div class="__toolbar">
      <div class="__row __centered">
        <div class="__logo">
          <img src="../assets/icons/log2.svg" alt width="106px" height="27px" />
        </div>
        <div class="__buttons">
          <button class="__tr" @click="login">Sign In</button>
          <button class="__bg" @click="$router.push({ name: 'signup' })">
            Register
          </button>
        </div>
      </div>
    </div>
    <div class="__head"></div>
    <!-- company-profile display -->
    <div class="company-profile-container" v-animate-css="'fadeIn'">
      <div class="company-profile-body" v-if="item">
        <ul class="pitches-items">
          <li class="pitches-item">
            <panel-expand :expand="true">
              <template v-slot:header="{ options }">
                <div class="pitches-item-header">
                  <div class="pitches-item-brand">
                    <img
                      v-if="item.company_logo"
                      :src="$fullUrl('images/profiles/' + item.company_logo)"
                    />
                    <img v-else src="@/assets/icons/logo_avatar.svg" alt />
                  </div>
                  <div class="content">
                    <div class="title-row">
                      <label>{{ item.title | validate }}</label>
                      <span>{{ item.assignment_name | validate }}</span>
                    </div>
                    <div class="options">
                      <button
                        class="toogle-panel-btn"
                        @click="options.expanded = !options.expanded"
                        v-if="false"
                      >
                        <span class="fa fa-angle-down"></span>
                      </button>
                      <span class="date">{{
                        item.created_at | formatDate | validate
                      }}</span>
                    </div>
                  </div>
                </div>
              </template>
              <template v-slot:main="{ options }">
                <div class="pitches-item-body">
                  <div class="pitches-info">
                    <h5>Description</h5>
                    <p>{{ item.description | validate }}</p>
                  </div>

                  <ul class="consultants-items">
                    <li class="consultants-starter">
                      <div class="consultants-item-header">
                        <label
                          >All Consultants ({{
                            item.consultants.length | validate
                          }})</label
                        >
                      </div>
                    </li>

                    <li
                      class="consultants-item"
                      v-for="(val, j) in item.consultants"
                      :key="j"
                    >
                      <panel-expand :expand="j === 0">
                        <template v-slot:header="{ options }">
                          <div class="consultants-item-header">
                            <div class="consultants-item-brand">
                              <img
                                v-if="val.profile_picture"
                                :src="
                                  $fullUrl(
                                    'images/profiles/' + val.profile_picture
                                  )
                                "
                                alt
                              />
                              <img
                                v-else
                                src="@/assets/icons/logo_avatar.svg"
                                alt
                              />
                            </div>
                            <div class="content">
                              <div class="title-row">
                                <label
                                  >{{ val.first_name | validate }}
                                  {{ val.last_name | validate }}</label
                                >
                                <span
                                  v-if="
                                    val.profile.location &&
                                    val.profile.location.country &&
                                    val.profile.location.city
                                  "
                                  >{{
                                    val.profile.location.country.name
                                      | validate
                                  }},
                                  {{
                                    val.profile.location.city.name | validate
                                  }}</span
                                >
                              </div>
                              <div class="options">
                                <dropdown-menu>
                                  <ul>
                                    <li>
                                      <a @click.prevent="downloadCv(val)"
                                        >Download Cv</a
                                      >
                                    </li>
                                    <li>
                                      <a @click.prevent="gotoProfile(val)"
                                        >View Profile</a
                                      >
                                    </li>
                                  </ul>
                                </dropdown-menu>

                                <span
                                  class="date"
                                  v-if="val.profile.available_from"
                                  >{{
                                    val.profile.available_from
                                      | formatDate
                                      | validate
                                  }}</span
                                >
                                <span class="status" v-else>Not Available</span>
                                <button
                                  class="toogle-panel-btn"
                                  @click="options.expanded = !options.expanded"
                                  v-if="!options.expanded"
                                >
                                  <span class="fa fa-angle-down"></span>
                                </button>
                              </div>
                            </div>
                          </div>
                        </template>
                        <template v-slot:main="{ options }">
                          <div class="consultants-item-body">
                            <div class="consultants-info">
                              <h5>Telephone</h5>
                              <p>{{ val.profile.phone || "" | validate }}</p>
                              <h5>E-mail</h5>
                              <p>{{ val.email | validate }}</p>
                              <h5>Description</h5>
                              <p v-html="val.profile.description"></p>
                              <h5>Skills</h5>
                              <div class="skills-widget">
                                <div class="skills_content__wrapper">
                                  <div class="skill_box">
                                    <div class="skill_box_header">
                                      <label>Tools</label>
                                    </div>
                                    <div
                                      class="skill_box_body"
                                      v-if="val.skills.tools.length > 0"
                                    >
                                      <div
                                        class="row__item"
                                        v-for="(
                                          value, i
                                        ) in val.skills.tools.slice(0, 5)"
                                        :key="i"
                                      >
                                        <span>{{ value.name | validate }}</span>
                                        <star-rating
                                          inactive-color="#C1C1C1"
                                          :read-only="true"
                                          active-color="#1BA5A4"
                                          :star-size="14"
                                          :show-rating="false"
                                          v-model="value.level"
                                        ></star-rating>
                                      </div>
                                    </div>
                                    <div class="skill_box_body" v-else>
                                      <div class="empty-skills">
                                        <p>Have not added any tool yet.</p>
                                      </div>
                                    </div>
                                  </div>
                                  <div class="skill_box">
                                    <div class="skill_box_header">
                                      <label>Domains</label>
                                    </div>
                                    <div
                                      class="skill_box_body"
                                      v-if="val.skills.domains.length > 0"
                                    >
                                      <div
                                        class="row__item"
                                        v-for="(
                                          value, i
                                        ) in val.skills.domains.slice(0, 5)"
                                        :key="i"
                                      >
                                        <span>{{ value.name | validate }}</span>
                                        <star-rating
                                          inactive-color="#C1C1C1"
                                          :read-only="true"
                                          active-color="#1BA5A4"
                                          :star-size="14"
                                          :show-rating="false"
                                          v-model="value.level"
                                        ></star-rating>
                                      </div>
                                    </div>
                                    <div class="skill_box_body" v-else>
                                      <div class="empty-skills">
                                        <p>Have not added any domain yet.</p>
                                      </div>
                                    </div>
                                  </div>
                                  <div class="skill_box">
                                    <div class="skill_box_header">
                                      <label>Languages</label>
                                    </div>
                                    <div
                                      class="skill_box_body"
                                      v-if="val.skills.languages.length > 0"
                                    >
                                      <div
                                        class="row__item"
                                        v-for="(
                                          value, i
                                        ) in val.skills.languages.slice(0, 5)"
                                        :key="i"
                                      >
                                        <span>{{
                                          value.lang.name | validate
                                        }}</span>
                                        <star-rating
                                          inactive-color="#C1C1C1"
                                          :read-only="true"
                                          active-color="#1BA5A4"
                                          :star-size="14"
                                          :show-rating="false"
                                          v-model="value.level"
                                        ></star-rating>
                                      </div>
                                    </div>
                                    <div class="skill_box_body" v-else>
                                      <div class="empty-skills">
                                        <p>Have not added any language yet.</p>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div class="next_skills_content__wrapper">
                                  <div class="skill_box">
                                    <div class="skill_box_header">
                                      <label>Competences</label>
                                    </div>
                                    <div
                                      class="skill_box_body"
                                      v-if="val.skills.competences.length > 0"
                                    >
                                      <div
                                        class="row__item"
                                        v-for="(
                                          value, i
                                        ) in val.skills.competences.slice(0, 5)"
                                        :key="i"
                                      >
                                        <span>{{ value.name | validate }}</span>
                                        <star-rating
                                          inactive-color="#C1C1C1"
                                          :read-only="true"
                                          active-color="#1BA5A4"
                                          :star-size="14"
                                          :show-rating="false"
                                          v-model="value.level"
                                        ></star-rating>
                                      </div>
                                    </div>
                                    <div class="skill_box_body" v-else>
                                      <div class="empty-skills">
                                        <p>
                                          Have not added any competence yet.
                                        </p>
                                      </div>
                                    </div>
                                  </div>
                                  <div class="skill_box">
                                    <div class="skill_box_header">
                                      <label>Roles</label>
                                    </div>
                                    <div
                                      class="skill_box_body"
                                      v-if="val.skills.roles.length > 0"
                                    >
                                      <div
                                        class="row__item"
                                        v-for="(
                                          value, i
                                        ) in val.skills.roles.slice(0, 5)"
                                        :key="i"
                                      >
                                        <span>{{ value.name | validate }}</span>
                                        <star-rating
                                          inactive-color="#C1C1C1"
                                          :read-only="true"
                                          active-color="#1BA5A4"
                                          :star-size="14"
                                          :show-rating="false"
                                          v-model="value.level"
                                        ></star-rating>
                                      </div>
                                    </div>
                                    <div class="skill_box_body" v-else>
                                      <div class="empty-skills">
                                        <p>Have not added any role yet.</p>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div class="consultants-item-body-option">
                              <button
                                class="toogle-panel-btn"
                                @click="options.expanded = !options.expanded"
                              >
                                <span
                                  class="fa fa-angle-up"
                                  v-show="options.expanded"
                                ></span>
                              </button>
                            </div>
                          </div>
                        </template>
                      </panel-expand>
                    </li>
                  </ul>
                  <button
                    class="toogle-panel-btn"
                    @click="options.expanded = !options.expanded"
                    v-if="false"
                  >
                    <span class="fa fa-angle-down"></span>
                  </button>
                </div>
              </template>
            </panel-expand>
          </li>
        </ul>
        <div class="pitches-item-body-option" v-if="false">
          <textarea
            class="comment-textarea"
            v-model="form_data.message"
            placeholder="Type your comment here..."
            rows="10"
          ></textarea>
          <span class="error-message" v-if="error_msg"
            >Please enter your comment</span
          >
          <div class="btns">
            <app-dialog
              title="Pitch invitation"
              ask="Are you sure you want to accept this Pitch invitation?"
              yesText="Accept"
              noText="Cancel"
              yesBtnClass="btn-default"
              @onComfirm="confirmNotification()"
            >
              <consultfied-button class="accept-btn" :loading="accept_loading"
                >Accept</consultfied-button
              >
            </app-dialog>
            <app-dialog
              title="Pitch invitation"
              ask="Are you sure you want to reject this Pitch invitation?"
              yesText="Accept"
              noText="Cancel"
              yesBtnClass="btn-default"
              @onComfirm="rejectNotification()"
            >
              <consultfied-button :loading="reject_loading" class="reject-btn"
                >Reject</consultfied-button
              >
            </app-dialog>
          </div>
        </div>
      </div>
    </div>
    <!-- End -->
    <export-cv
      :visible="showExport"
      :id="user.id"
      :names="user.name"
      @onClose="showExport = false"
    />
  </div>
</template>

<script>
import panelExpand from "@/components/Partials/panelExpand";
import dropdownMenu from "@/components/Partials/dropdownMenu";
import appDialog from "@/components/Dialog/AppDialog.vue";
import ManageConsultant from "@/components/Company/ManageConsultant.vue";
import consultfiedButton from "@/components/helper/consultfiedButton.vue";
import { mapGetters } from "vuex";
import { eventBus } from "@/main";
import HelpToolTip from "@/components/helper/HelpToolTip.vue";
import selectCustomer from "@/components/Company/selectCustomer.vue";
import exportCv from "@/components/Company/ManageConsultantComponets/Modals/exportCv.vue";

export default {
  name: "pitches",
  components: {
    panelExpand,
    dropdownMenu,
    appDialog,
    ManageConsultant,
    consultfiedButton,
    HelpToolTip,
    selectCustomer,
    exportCv,
  },
  props: {},
  data: () => {
    return {
      user: {
        id: null,
        name: "new cv",
      },
      showExport: false,
      error_msg: false,
      item: null,
      accept_loading: false,
      reject_loading: false,
      form_data: {
        id: null,
        manager_id: null,
        pitch_id: null,
        status: 1,
        message: "",
      },
    };
  },
  mounted() {
    let vm = this;
    if (vm.$route.params.pitch_id && vm.$route.params.manager_id) {
      vm.form_data.pitch_id = vm.$route.params.pitch_id;
      vm.form_data.manager_id = vm.$route.params.manager_id;
      vm.form_data.id = vm.$route.params.invitation_id;
      vm.getPitch(vm.$route.params.pitch_id);
    }
  },
  computed: {},
  watch: {},
  methods: {
    gotoProfile(user) {
      this.$router.push({ name: "profile-view", params: { id: user.id } });
    },
    downloadCv(val) {
      let vm = this;
      vm.user.id = val.id;
      vm.user.name = val.first_name + " " + val.last_name;
      vm.showExport = true;
    },
    addToMyPitch(id) {
      let vm = this;
      vm.$store
        .dispatch("CUSTOMER_ADD_PITCH", { id: id })
        .then((value) => {
          vm.$notify({
            group: "status",
            title: "Important message",
            text: "This pitch was added to your pitch",
            type: "success",
            duration: 3000,
          });
        })
        .catch((reason) => {
          vm.$notify({
            group: "status",
            title: "Something wrong",
            text: "Pitch not added to your pitch list",
            type: "warn",
            duration: 3000,
          });
        });
    },
    rejectNotification() {
      let vm = this;
      vm.error_msg = false;
      if (vm.form_data.message) {
        vm.accept_loading = true;
        vm.form_data.status = 0;
        vm.$store
          .dispatch("CUSTOMER_REJECT_PITCH", vm.form_data)
          .then((value) => {
            vm.accept_loading = false;
            vm.$router.push({ name: "notifications" });
          })
          .catch((reason) => {
            console.log(reason);
            vm.accept_loading = false;
          });
      } else {
        vm.error_msg = true;
      }
    },
    confirmNotification() {
      let vm = this;
      vm.error_msg = false;
      if (vm.form_data.message) {
        vm.accept_loading = true;
        vm.form_data.status = 1;
        vm.$store
          .dispatch("CUSTOMER_ACCEPT_PITCH", vm.form_data)
          .then((value) => {
            vm.accept_loading = false;
            vm.$router.push({ name: "notifications" });
          })
          .catch((reason) => {
            console.log(reason);
            vm.accept_loading = false;
          });
      } else {
        vm.error_msg = true;
      }
    },
    getPitch(id) {
      let vm = this;
      vm.$store
        .dispatch("GET_SINGLE_PITCH", { id: id })
        .then((responce) => {
          vm.item = responce.data;
          let consultants = vm.processSkills(vm.item.consultants);
          eventBus.$set(vm.item, "consultants", consultants);
        })
        .catch((error) => {});
    },
    processSkills(consultants) {
      return consultants.map((item) => {
        let skills = {
          tools: [],
          domains: [],
          languages: [],
          competences: [],
          roles: [],
        };
        if (item.skills.length && item.skills.length > 0) {
          item.skills.forEach((skill) => {
            skill.tools.forEach((item) => {
              let obj = {
                name: item.name,
                priority: item.priority,
                level: parseInt(item.priority),
              };
              skills.tools.push(obj);
            });
            skill.domains.forEach((item) => {
              let obj = {
                name: item.name,
                priority: item.priority,
                level: parseInt(item.priority),
              };
              skills.domains.push(obj);
            });
            skill.competences.forEach((item) => {
              let obj = {
                name: item.name,
                priority: item.priority,
                level: parseInt(item.priority),
              };
              skills.competences.push(obj);
            });
            skill.roles.forEach((item) => {
              let obj = {
                name: item.name,
                priority: item.priority,
                level: parseInt(item.priority),
              };
              skills.roles.push(obj);
            });
            skill.languages.forEach((item) => {
              if (item.lang) {
                let obj = {
                  lang: { name: item.lang.name },
                  level: parseInt(item.level),
                };
                skills.languages.push(obj);
              }
            });
          });
        }
        eventBus.$set(item, "skills", skills);
        return item;
      });
    },
    login() {
      this.$router.push({ name: "login" });
    },
  },
};
</script>
<style lang="scss" scoped>
.pitches-wrapper {
  width: 100%;
  display: flex;
  align-items: center;
  flex-direction: column;
  margin-top: 49px;
  .__toolbar {
    width: 100%;
    position: fixed;
    top: 0;
    height: 49.5px;
    background: linear-gradient(45deg, #1ba5a4, #1885ad);
    z-index: 9999;
    .__row {
      margin: 0 auto;
      width: 800px;
      display: flex;
      padding-top: 10px;
      justify-content: space-between;
      .__buttons {
        display: flex;
        .__bg {
          border-radius: 5.3px;
          background-color: #ffffff;
          font-family: "Nunito", sans-serif;
          font-size: 14px;
          font-weight: 300;
          font-stretch: normal;
          font-style: normal;
          line-height: 1.2;
          letter-spacing: normal;
          text-align: center;
          color: #00749f;
        }
      }
      .__tr {
        font-family: "Nunito", sans-serif;
        font-size: 14px;
        font-weight: 300;
        font-stretch: normal;
        font-style: normal;
        outline: none;
        line-height: 1.2;
        letter-spacing: normal;
        text-align: center;
        color: #ffffff;
      }
      button {
        padding: 0 20px;
        height: 30px;
      }
    }
  }
  .__head {
    height: 50px;
    width: 100%;
    background-image: url("../assets/images/backgrounds/wallpaper.svg");
    background-size: cover;
    margin-bottom: 15px;
    /*@media (min-width: 300px) and (max-width: 630px) {*/
    /*    display: none;*/
    /*}*/
  }
  .company-profile-container {
    padding: 1px;
    width: 800px;
    .company-profile-body {
      border-radius: 5px;
      margin-bottom: 20px;
      background: #ffffff;
      ul.pitches-items {
        padding: 20px 20px;
        list-style: none;
        .pitches-starter {
          margin-bottom: 6px;
          .pitches-item-header {
            display: flex;
            align-items: center;
            justify-content: space-between;
            padding: 16px 0px;
            label {
              color: #000000;

              font-size: 16px;
            }
            .btn-add-assignment {
              color: #1ba5a4;
              border: none;
              padding: 10px 10px;
              font-size: 14px;
              outline: none;
              cursor: pointer;

              font-style: italic;
              background: transparent;
            }
          }
          p {
            color: #131313;
          }
        }
        .pitches-item {
          background: #f5f5f5 0% 0% no-repeat padding-box;
          border-radius: 5px;
          margin-bottom: 10px;
          .pitches-item-header {
            display: grid;
            padding: 0px 4px;
            grid-template-columns: 90px calc(98% - 90px);
            grid-column-gap: 20px;
            .pitches-item-brand {
              display: flex;
              justify-content: center;
              align-items: center;
              width: 90px;
              height: 90px;
              margin-right: 15px;
              padding-top: 10px;

              img {
                width: 70px;
                height: 70px;
                border-radius: 50%;
                object-fit: cover;
              }
            }
            .content {
              display: flex;
              width: 100%;
              align-items: center;
              padding-right: 15px;
              .title-row {
                width: calc(100% - 200px);

                label {
                  display: block;
                  font-size: 14px;

                  margin-bottom: 1px;
                  font-weight: 800;
                }
                span {
                  color: #808080;

                  font-size: 13px;
                  margin-bottom: 6px;
                }
              }
              .options {
                display: flex;
                align-items: flex-end;
                flex-direction: column;
                width: 200px;
                .date {
                  color: #808080;

                  font-size: 13px;
                }
                .status {
                  color: #000;

                  font-size: 13px;
                }
                .toogle-panel-btn {
                  width: 19px;
                  padding: 0;
                  height: 22px;
                  font-size: 20px;
                  position: relative;
                  top: -3px;
                  right: -5px;
                }
              }
            }
            .toogle-panel-btn {
              padding: 1px 40px;
              font-size: 30px;
              background: transparent;
              border: none;
              outline: none;
              cursor: pointer;
              color: #ccc;
            }
          }
          .pitches-item-body {
            padding: 10px;
            .pitches-info {
              h5 {
                text-align: left;
                color: #6e6e6e;
                font-size: 14px;
              }
              p {
                text-align: left;
                color: #000;
                font-size: 13px;
                font-weight: 800;
              }
            }
            ul.consultants-items {
              padding: 0px 0px;
              padding-bottom: 20px;
              list-style: none;
              border-bottom-left-radius: 5px;
              border-bottom-right-radius: 5px;
              .consultants-starter {
                margin-bottom: 6px;
                .consultants-item-header {
                  display: flex;
                  align-items: center;
                  justify-content: space-between;
                  padding: 16px 0px;
                  label {
                    color: #000000;

                    font-size: 16px;
                  }
                  .export-cv-btn {
                    color: #fff;
                    border: none;
                    padding: 10px 20px;
                    font-size: 14px;
                    outline: none;
                    cursor: pointer;

                    background: #1ba5a4;
                    height: 40px;
                    border-radius: 5px;
                  }
                }
                p {
                  color: #131313;
                }
              }
              .consultants-item {
                background: #ffffff;
                border-radius: 5px;
                margin-bottom: 10px;
                .consultants-item-header {
                  display: grid;
                  padding: 0px 4px;
                  grid-template-columns: 90px calc(98% - 90px);
                  grid-column-gap: 20px;
                  .consultants-item-brand {
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    width: 90px;
                    height: 90px;
                    margin-right: 15px;
                    padding-top: 10px;

                    img {
                      width: 70px;
                      height: 70px;
                      border-radius: 50%;
                      object-fit: cover;
                    }
                  }
                  .content {
                    display: flex;
                    width: 100%;
                    align-items: center;
                    padding-right: 15px;
                    .title-row {
                      width: calc(100% - 200px);

                      label {
                        display: block;
                        font-size: 14px;

                        margin-bottom: 1px;
                        font-weight: 800;
                      }
                      span {
                        color: #808080;

                        font-size: 13px;
                        margin-bottom: 6px;
                      }
                    }
                    .options {
                      display: flex;
                      align-items: flex-end;
                      flex-direction: column;
                      width: 200px;
                      .date {
                        color: #808080;

                        font-size: 13px;
                      }
                      .status {
                        color: #000;

                        font-size: 13px;
                      }
                      .toogle-panel-btn {
                        width: 19px;
                        padding: 0;
                        height: 22px;
                        font-size: 20px;
                        position: relative;
                        top: -3px;
                        right: -5px;
                      }
                    }
                  }
                  .toogle-panel-btn {
                    padding: 1px 40px;
                    font-size: 30px;
                    background: transparent;
                    border: none;
                    outline: none;
                    cursor: pointer;
                    color: #ccc;
                  }
                }
                .consultants-item-body {
                  padding: 10px;
                  .consultants-info {
                    h5 {
                      text-align: left;
                      color: #6e6e6e;
                      font-size: 14px;
                    }
                    p {
                      text-align: left;
                      color: #000;
                      font-size: 13px;
                      font-weight: 800;
                    }

                    .skills-widget {
                      .skills_content__wrapper {
                        display: grid;
                        grid-template-columns: 1fr 1fr 1fr;
                        grid-column-gap: 10px;
                        margin-bottom: 10px;
                        @media (min-width: 300px) and (max-width: 630px) {
                          grid-template-columns: 1fr;
                        }
                        .skill_box {
                          min-width: 0;
                          display: flex;
                          flex-direction: column;
                          width: 100%;
                          background: #f5f5f5;
                          border-radius: 5px;
                          margin-bottom: 15px;
                          .skill_box_header {
                            border-bottom: 2px solid #fff;
                            height: 50px;
                            display: flex;
                            align-items: center;
                            justify-content: space-around;
                            padding: 0px 15px;
                            label {
                              color: #0884af;
                              width: 100%;
                              font-size: 15px;
                              font-weight: 800;
                            }
                          }
                          .skill_box_body {
                            padding: 0px 15px;
                            .empty-skills {
                              display: flex;
                              flex-direction: column;
                              align-items: center;
                              height: 200px;
                              justify-content: center;
                              p {
                                text-align: center;
                                margin-bottom: 20px;
                                color: #8d8d8d;
                              }
                              button {
                                width: 133px;
                                height: 36px;
                                background: #1890a9 0% 0% no-repeat padding-box;
                                border-radius: 5px;
                                color: #fff;
                              }
                            }
                            .row__item {
                              margin-top: 10px;
                              display: flex;
                              margin-bottom: 10px;
                              justify-content: space-between;
                              width: 100%;
                              span {
                                color: #000000;
                                font-weight: normal;
                                margin-top: 2px;
                                font-size: 14px;
                                font-weight: 800;
                              }
                            }
                          }
                        }
                      }
                      .next_skills_content__wrapper {
                        display: grid;
                        grid-template-columns: 1fr 1fr;
                        grid-column-gap: 10px;
                        @media (min-width: 300px) and (max-width: 630px) {
                          grid-template-columns: 1fr;
                        }
                        .skill_box {
                          min-width: 0;
                          display: flex;
                          flex-direction: column;
                          width: 100%;
                          background: #f5f5f5;
                          border-radius: 5px;
                          margin-bottom: 15px;
                          .skill_box_header {
                            border-bottom: 2px solid #fff;
                            height: 50px;
                            display: flex;
                            align-items: center;
                            justify-content: space-around;
                            padding: 0px 15px;
                            label {
                              color: #0884af;
                              width: 100%;
                              font-size: 15px;
                              font-weight: 800;
                            }
                          }
                          .skill_box_body {
                            padding: 0px 15px;
                            .empty-skills {
                              display: flex;
                              flex-direction: column;
                              align-items: center;
                              height: 200px;
                              justify-content: center;
                              p {
                                text-align: center;
                                margin-bottom: 20px;
                                color: #8d8d8d;
                              }
                              button {
                                width: 133px;
                                height: 36px;
                                background: #1890a9 0% 0% no-repeat padding-box;
                                border-radius: 5px;
                                color: #fff;
                              }
                            }
                            .row__item {
                              margin-top: 10px;
                              display: flex;
                              margin-bottom: 10px;
                              justify-content: space-between;
                              width: 100%;
                              span {
                                color: #000000;
                                font-weight: normal;
                                margin-top: 2px;
                                font-size: 14px;
                                font-weight: 800;
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                  .consultants-item-body-option {
                    display: flex;
                    justify-content: flex-end;
                    .toogle-panel-btn {
                      padding: 1px 9px;
                      font-size: 30px;
                      background: transparent;
                      border: none;
                      outline: none;
                      cursor: pointer;
                      color: #ccc;
                      height: 36px;
                      width: 19px;
                      padding: 0;
                      height: 22px;
                      font-size: 20px;
                      position: relative;
                      top: -3px;
                      right: -5px;
                    }
                  }
                }
              }
            }
            .pitches-item-body-option {
              display: flex;
              justify-content: flex-end;
              .toogle-panel-btn {
                padding: 1px 9px;
                font-size: 30px;
                background: transparent;
                border: none;
                outline: none;
                cursor: pointer;
                color: #ccc;
                height: 36px;
                width: 19px;
                padding: 0;
                height: 22px;
                font-size: 20px;
                position: relative;
                top: -3px;
                right: -5px;
              }
            }
          }
        }
      }
      .pitches-item-body-option {
        display: flex;
        flex-direction: column;
        padding: 0px 19px;
        .comment-textarea {
          height: 60px;
          border: 1px solid #ddd;
          padding: 15px;
          outline: none;
        }
        .error-message {
          color: red;
          font-size: 12px;
        }
        .btns {
          padding: 15px 0px;
          display: flex;
          align-items: center;
          justify-content: center;
          .accept-btn {
            width: 107px;
            height: 37px;
            background: #1885ad 0% 0% no-repeat padding-box;
            border-radius: 5px;
            color: #fff;
            outline: none;
            margin-right: 20px;
            display: flex;
            align-items: center;
            justify-content: center;
          }
          .reject-btn {
            width: 107px;
            height: 37px;
            border: 1px solid #1885ad;
            border-radius: 5px;
            color: #1885ad;
            outline: none;
            display: flex;
            align-items: center;
            justify-content: center;
          }
        }
      }
    }
  }
}
</style>